import React, { Component } from "react";
import { Upload, Row, Col } from "antd";
import "./UploadComponent.less";
import { injectIntl } from "react-intl";

class UploadComponent extends Component {
  getBase64 = async (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  handleUpload = (info) => {
    
    if (info.file.status === "uploading") {
      this.getBase64(info.file.originFileObj, (imageUrl) => {
        const lastDot = info.file.name.lastIndexOf(".");
        const ext = info.file.name.substring(lastDot + 1);
        const image = {
          uid: info.file.uid,
          name: info.file.name,
          fileType: ext,
          base64: true,
          status: "done",
          url: imageUrl,
          fileData: info.file.originFileObj,
          contentType: info.file.type,
          fileSize: info.file.size,
        };
        this.props.getBase64File(image, imageUrl);
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col className="custom-upload">
            <Upload
              // className="upload  delete-hide preview-icon-hide"
              customRequest={() => {}}
              {...this.props}
              onPreview={(file) => this.handlePreviewImage(file)}
              onChange={this.handleUpload}
              onRemove={(e) => {
                if (!this.props.disabled) {
                  this.uploadedFile = "";
                  this.props?.onImageRemove(e);
                }
              }}
            >
              {this.props.children}
            </Upload>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default injectIntl(UploadComponent);
